import React from 'react';
import Select from '@deprecated-ui/common/Select';
import { useSelector } from 'react-redux';
import { valuationSelectors } from 'features/valuation/slice';
import styled from 'styled-components';
import { Skeleton } from 'antd';
import { Label } from '../styled';

const { Option } = Select;

const SSelect = styled(Select)`
  margin-top: 10px;
  margin-bottom: 15px;

  .ant-select-selector {
    border-radius: 3px !important;
  }
`;

const SSkeleton = styled(Skeleton.Input)`
  display: block;

  & > span {
    width: 100%;
    margin: 10px 0px 15px 0px;
    border-radius: 2px;
  }
`;

const ValuationMethod = () => {
  const { valuationMetricOptions } = useSelector(valuationSelectors);

  const {
    data: { name },
  } = valuationMetricOptions;

  return (
    <>
      {/* @ts-expect-error */}
      <Label htmlFor="method">Valuation Method</Label>
      {name ? (
        <SSelect id="method" width="100%" defaultValue={name}>
          <Option value={name}>Price to Earnings Method</Option>
        </SSelect>
      ) : (
        <SSkeleton active />
      )}
    </>
  );
};

export default ValuationMethod;
